import React from 'react';
import Icon from '../../../components/AppIcon';

const ReconciliationSummary = ({ data, period }) => {
  const summaryCards = [
    {
      label: 'POS Transactions',
      value: data?.posTransactions,
      icon: 'ShoppingCart',
      color: 'var(--color-primary)',
      format: 'currency'
    },
    {
      label: 'Membership Payments',
      value: data?.membershipPayments,
      icon: 'CreditCard',
      color: 'var(--color-success)',
      format: 'currency'
    },
    {
      label: 'Bank Deposits',
      value: data?.bankDeposits,
      icon: 'Building',
      color: 'var(--color-accent)',
      format: 'currency'
    },
    {
      label: 'Discrepancies',
      value: data?.discrepancies,
      icon: 'AlertTriangle',
      color: data?.discrepancies > 0 ? 'var(--color-error)' : 'var(--color-success)',
      format: 'number'
    }
  ];

  const formatValue = (value, format) => {
    if (format === 'currency') return `$${value?.toLocaleString()}`;
    return value;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
            {period?.charAt(0)?.toUpperCase() + period?.slice(1)} Reconciliation Summary
          </h2>
          <p className="text-sm text-muted-foreground">
            Last updated: {data?.lastUpdated}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <div className="text-right">
            <div className="text-sm text-muted-foreground mb-1">Reconciliation Rate</div>
            <div className="text-2xl font-semibold text-success data-text">{data?.reconciliationRate}%</div>
          </div>
          <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {summaryCards?.map((card, idx) => (
          <div key={idx} className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${card?.color}15` }}>
                <Icon name={card?.icon} size={20} color={card?.color} />
              </div>
            </div>
            <div className="text-sm text-muted-foreground mb-1">{card?.label}</div>
            <div className="text-2xl font-semibold text-foreground data-text">
              {formatValue(card?.value, card?.format)}
            </div>
          </div>
        ))}
      </div>
      {data?.discrepancies === 0 && (
        <div className="mt-6 bg-success/10 border border-success/20 rounded-lg p-4 flex items-center gap-3">
          <Icon name="CheckCircle" size={24} color="var(--color-success)" />
          <div>
            <div className="text-sm font-semibold text-success">All Transactions Reconciled</div>
            <div className="text-xs text-muted-foreground">No discrepancies detected for this period</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReconciliationSummary;